export function filterRecommendedRelations(recommendedRelations, existingRelations) {
    return recommendedRelations.filter(relation => {
        const isBetweenUserProfile = relation.from === 'User Profile' || relation.to === 'User Profile';
        return !isBetweenUserProfile && !existingRelations.some(existingRelation => {
            return (
                (
                    (
                        existingRelation.fromEntity.name === relation.from &&
                        existingRelation.toEntity.name === relation.to
                    ) ||
                    (
                        existingRelation.fromEntity.name === relation.to &&
                        existingRelation.toEntity.name === relation.from
                    )
                )
            );
        });
    })
}